export default class CellItemElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('cell-item', CellItemElement);